// Google Ads lead conversion.
// Called ONLY after the backend confirms a successful lead submission — never on
// submit-click, validation failure, or a failed API request. Fires once per call.
export const trackLeadConversion = () => {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', 'conversion', { send_to: 'AW-18435427084/MmZ4CJHHivEcEIyW2dZE' });
  }
};
